import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
import { baseUrl } from "../utils/baseUrl.js";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { object, string } from "yup";

export const CheckOutContext = createContext();

export default function CheckOutContextProvider({ children }) {

    const [errorMessage, setErrorMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [orders, setOrders] = useState([])
    let token = localStorage.getItem('authorization')
    const notify = (msg, type) => toast[type](msg);

    const getOrders = () => {
        axios.get(`${baseUrl}/orders/user`, {
            headers: {
                Authorization: `ecomm__${localStorage.getItem('authorization')}`
            }
        }).then(response => {
            setOrders(response.data.orders);
        }).catch(error => {
        })
    }

    useEffect(() => {
        getOrders()
    }, [])

    let validationSchema = object({
        address: string().required().min(10),
        couponCode: string().optional(),
        phone: string().required().matches(/^(\+201|01|00201)[0-2,5]{1}[0-9]{8}/, 'must be a valid number'),
        // products: array().of(object().shape({
        //     productId: string().required(),
        //     quantity: string().required()
        // })).optional(),
    });

    const makeCheckout = async (values) => {
        setIsLoading(true)
        await axios(`${baseUrl}/orders`, {
            method: 'post',
            headers: {
                'Authorization': `ecomm__${token}`
            },
            data: values
        }).then((response) => {
            if (response.status === 201) {
                if (response?.data?.order?.paymentMethod === 'card') {
                    // window.open(response.data?.session?.url)
                    window.location.href = response?.data?.session?.url
                } else if (response.data?.order.paymentMethod === 'cash') {
                    notify("Successful Order", "success")
                }
                getOrders()
                setIsLoading(true)
            }
        }).catch((error) => {
            if (error.response.data) {
                setErrorMessage(error.response.data.error)
                notify(error.response.data.error, "error")
            }
            if (error.response?.data?.Errors?.length) {
                setErrorMessage(error.response.data.error)
                notify(error.response.data.error, "error")
            }
        })
    }


    let checkoutFormik = useFormik({
        initialValues: {
            address: '',
            phone: '',
            paymentMethod: '',
            couponCode: '',
            // products: [
            //     {
            //         productId: '',
            //         quantity: '',
            //     }
            // ],
        },
        validationSchema,
        onSubmit: (values) => {
            if (!values.couponCode) {
                delete values.couponCode;
            }
            // if (!values.products.length) {
            //     delete values.products;
            // }
            makeCheckout(values)
        }
    })


    const addReview = async (productId, text, rate, onClose) => {
        await axios(`${baseUrl}/reviews/${productId}`, {
            method: 'post',
            headers: {
                'Authorization': `ecomm__${token}`
            },
            data: {
                text,
                rate
            }
        }).then(response => {
            notify(response?.data?.message, "success")
            onClose()
        }).catch(err => {
            if (err.response?.data?.error) { notify(err.response?.data?.error, "error") }
            if (err.response?.data?.Errors?.length) {
                notify(err.response?.data?.Errors[0]?.message, "error")
            }
        })
    }

    const cancelOrder = (reason, orderId, onClose) => {
        axios(`${baseUrl}/orders/${orderId}`, {
            method: 'patch',
            headers: {
                'Authorization': `ecomm__${token}`
            },
            data: {
                reason
            }
        }).then((response) => {
            notify(response?.data?.message, "success")
            getOrders()
            onClose()
        }).catch((error) => {
            notify(error.response?.data?.error, "error")
        })
    }

    return (
        <CheckOutContext.Provider value={{ getOrders, orders, cancelOrder, checkoutFormik, addReview, errorMessage, isLoading }} >
            {children}
        </CheckOutContext.Provider>
    )

}
